import { APICall } from ".."

const ControllerName = "MobShared"

export const GetUsersPharmacies = () => {
    return APICall("get", ControllerName + "/Hospitals/GetUserPharmacies")
}

export const GetHospitalsMedicines = (pharmId: number, hospitalId: number, includeAllMedicines: boolean = false) => {
    return APICall("get", ControllerName + `/Medicines/GetHospitalMedicines?pharmacyId=${pharmId || ""}&hospitalId=${hospitalId || ""}&includeAllMedicines=${includeAllMedicines}`)
}

export const GetDoseInfoForMedicines = (decisionMedicineId: number) => {
    return APICall("get", ControllerName + `/Medicines/GetDoseInfo?decisionMedicineId=${decisionMedicineId}`)
}

export const GetRequestForPrint = (id: number) => {
    return APICall("get", ControllerName + `/Requests/GetRequestForPrint/${id}`)
}

export const GetPatientHospitals = (id: number) => {
    return APICall("get", ControllerName + `/Patients/GetPatientHospitals/${id}`)
}

export const SearchPatient = (dataObject?: any) => {
    return APICall("get", ControllerName + `/Patients/Search?keyword=${dataObject?.keyword || ""}&textKeyword=${dataObject?.textKeyword || ""}`)
}

export const CalcAltDoseAmountMedicines = (data: any, hospitalId: number | null, pharmId: number | null) => {
    return APICall("post", ControllerName + `/Medicines/CalcAltDoseAmount?hospitalId=${hospitalId || ""}&pharmacyId=${pharmId || ""}`, data)
}

export const SubmitChangeRequestMedicinesRequest = (data: any) => {
    return APICall("post", ControllerName + `/Requests/SubmitChangeMedicinesRequest`, data)
}


export const GetParentHospitalConfiguration = (hospitalId: number) => {
    return APICall("get", ControllerName + `/GetHospitalConfigurations?hospitalId=${hospitalId}`)
}

export const GetServiceTypesLookup = () => {
    return APICall("get", ControllerName + `/ServiceTypes/Lookup`)
}

export const GetHospitalPickupLookup = (hospitalId: number) => {
    return APICall("get", ControllerName + `/hospital-pickup-lookup?hospitalId=${hospitalId}`)
}

export const GetBatchDispense = (requestId: number) => {
    return APICall("get", ControllerName + `/Requests/${requestId}/batch-dispense`)
}
